module.exports = "/_next/static/images/DownloadApp_MobileView-516d0700270d3fa0d863dc335f7dc015.png";